import React, {FC, useState} from "react";
import Table from "../../ui/Table";
import {IFlowExecution} from "../../../types/ApiTypes";
import { FaAngleDown, FaAngleUp, FaEdit, FaTimes, FaToggleOff, FaToggleOn, FaTrash } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import Modal from "../../ui/Modal";
import Button from "../../ui/Button";
import {AnimatePresence} from "framer-motion";

interface Props {
    policies: IFlowExecution[];
    onOrderUp: (policyId: number) => void;
    onOrderDown: (policyId: number) => void;
    onDelete: (policyId: number) => void;
    onEdit: (policyId: number) => void;
    onTogglePolicy: (policyId: number, isDisabled: boolean) => void;
}

const FlowPoliciesList: FC<Props> = (props) => {
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [currentToBeDeleted, setCurrentToBeDeleted] = useState<number>();
    const biggestOrder = props.policies.reduce((biggestOrder, policy) => {
       return Math.max(biggestOrder,policy.order)
    },0);

    return (
        <>
            <Table.Skeleton>
                <Table.THead>
                    <Table.HeadTR>
                        <Table.TH>Flow Name</Table.TH>
                        <Table.TH>Space-Typ</Table.TH>
                        <Table.TH>Action</Table.TH>
                        <Table.TH>Reihenfolge</Table.TH>
                        <Table.TH>Aktiv?</Table.TH>
                        <Table.TH/>
                    </Table.HeadTR>
                </Table.THead>
                <Table.TBody>
                    {props.policies.length > 0 ? (
                        props.policies.map((x) => (
                            <Table.BodyTR key={x.id}>
                                <Table.TD>{x.flow.name}</Table.TD>
                                <Table.TD>{x.group_type}</Table.TD>
                                <Table.TD>{x.action}</Table.TD>
                                <Table.TD>{x.order}</Table.TD>
                                <Table.TD>{x.isDisabled ? "Nein" : "Ja"}</Table.TD>
                                <Table.TD>
                                    <div className='flex gap-2'>
                                        {x.isDisabled ? (
                                            <FaToggleOff
                                                className='text-error-brighter cursor-pointer'
                                                onClick={() => props.onTogglePolicy(x.id, false)}
                                                data-tooltip-id='flowListTooltip'
                                                data-content='Policy aktivieren'
                                            />
                                        ) : (
                                            <FaToggleOn
                                                className='text-success-darker cursor-pointer'
                                                onClick={() => props.onTogglePolicy(x.id, true)}
                                                data-tooltip-id='flowListTooltip'
                                                data-content='Policy deaktivieren'
                                            />
                                        )}
                                        <FaTrash className='text-error-brighter cursor-pointer' onClick={() => {setShowConfirmationModal(true); setCurrentToBeDeleted(x.id)}} data-tooltip-id='flowListTooltip' data-content='Policy löschen'/>
                                        <FaEdit className='cursor-pointer' onClick={() => {props.onEdit(x.id)}} data-tooltip-id='flowListTooltip' data-content='Policy bearbeiten'/>
                                        {x.order > 1 && <FaAngleUp className='cursor-pointer' onClick={() => props.onOrderDown(x.id)} data-tooltip-id='flowListTooltip' data-content='Verschiebe nach oben'/>}
                                        {(x.order < biggestOrder && x.order !== 1) && <FaAngleDown className='cursor-pointer' onClick={() => props.onOrderUp(x.id)} data-tooltip-id='flowListTooltip' data-content='Verschiebe nach unten'/>}
                                        <Tooltip id='flowListTooltip'/>
                                    </div>
                                </Table.TD>
                            </Table.BodyTR>
                        ))
                    ) : (
                        <Table.BodyTR>
                            <Table.TD colspan={6}>Keine Flow Policies verfügbar</Table.TD>
                        </Table.BodyTR>
                    )}
                </Table.TBody>
            </Table.Skeleton>
            <AnimatePresence>
                {showConfirmationModal && (
                    <Modal isOpen={showConfirmationModal} onClose={() => setShowConfirmationModal(false)} title='Bestätige deine Aktion'>
                        <p className='mb-8'>
                            Bist du sicher, dass du diese Policy löschen möchtest? Das Flow, welches unter dieser Policy hängt, wird nicht mehr getriggert!
                        </p>
                        <div className='flex justify-end gap-4'>
                            <Button type='button' className='bg-success-darker hover:shadow-success-darker/20' onClick={() => {setShowConfirmationModal(false); props.onDelete(currentToBeDeleted!)}}><FaTrash className='mr-2'/>Ja 😎</Button>
                            <Button type='button' className='bg-error-brighter hover:shadow-error-brighter/20' onClick={() => {setShowConfirmationModal(false); setCurrentToBeDeleted(undefined)}}><FaTimes className='mr-2'/>Nein</Button>
                        </div>
                    </Modal>
                )}
            </AnimatePresence>
        </>
    );
};

export default FlowPoliciesList;